import CampaignSagas from "sagas/campaign";
import ContactSagas from "sagas/contact";
import MainSagas from "sagas/main";
import PaymentSagas from "sagas/payment";
import PerformanceSagas from "sagas/performance";
import SuggestionSagas from "sagas/suggestion";
import WizardSagas from "sagas/wizard";
import SettingSagas from "sagas/setting";
import GoogleSagas from "sagas/google";
import FacebookSagas from "sagas/facebook";
import BusinessSagas from "sagas/business";
import RCRMSagas from "sagas/rcrm";
import { all } from "redux-saga/effects";

export default function* root() {
  yield all([
    ...CampaignSagas,
    ...ContactSagas,
    ...MainSagas,
    ...PerformanceSagas,
    ...PaymentSagas,
    ...SuggestionSagas,
    ...WizardSagas,
    ...SettingSagas,
    ...GoogleSagas,
    ...FacebookSagas,
    ...BusinessSagas,
    ...RCRMSagas,
  ]);
}
